<template>
  <!-- 2hMmOggdTiPggqz2K5Pm -->
  <iframe id="awh-iframe" class="awh-iframe px-0" :src="showAhw ? iframeSrc : ''" frameborder="0"></iframe>
</template>
<script>
// import Api from '@/api/Api';
import Loading from '@/components/custom/Loading.vue';

export default {
  name: 'PreviewAhw',
  props: ['showAhw'],
  emits: ['closeAhw'],
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      baseUrl: 'https://dev.modalsupport.com/', // https://dev.modalsupport.com/
      libid: 'yNoSrTNlC2lrSx4KpTlc', //2hMmOggdTiPggqz2K5Pm // yNoSrTNlC2lrSx4KpTlc
      widgetptions: '?hct=1&hc=1',
    };
  },
  methods: {
    async initAhwContent() {
      this.isLoading = true;
    },
  },
  computed: {
    iframeSrc() {
      let hlProToolsLibId = process.env.VUE_APP_HLPROTOOLS_SUPPORT_LIB_ID;
      let baseUrl = '';
      if(['localhost'].some(envName =>  window.location.hostname.includes(envName))) {
        baseUrl = 'http://localhost:9499';
      } else if(['staging'].some(envName =>  window.location.hostname.includes(envName))) {
        baseUrl = 'https://hlpt-support-widget--staging-pqkw9198.web.app/';
      } else {
        baseUrl = 'https://dev.modalsupport.com';
      }
      // if(this.$store.state.parent_lib_id == process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID) {
      //   return `${baseUrl}/AdvancedWidget/${hlProToolsLibId}/dashboard?library_domain=${this.$store.state.library_domain}`;
      // } else {
        return `${baseUrl}/AdvancedWidget/${this.libid}/dashboard${this.widgetptions}`;
      // }
    },
  },
  mounted() {
    this.initAhwContent();
    window.addEventListener(
      'message',
      (e) => {
        let doc = document.querySelector('.ahw-preview-pannel');
        const data = e.data;
        if (e.data.event == 'addCompactClass') {
          document.body.classList.add(`compact-widget`);
        } else if (e.data.event == 'removeCompactClass') {
          document.body.classList.remove(`compact-widget`);
        } else if (data === 'closeWidget') {
          this.$emit('closeAhw', true);
        } else if (data === 'expand') {
          doc.classList.add('expanded-article');
        } else if (data === 'unexpand') {
          doc.classList.remove('expanded-article');
        }
      },
      false,
    );
  },
};
</script>
